import { Component, OnDestroy, OnInit } from '@angular/core';

import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { DashboardService } from './../../../../services/seed/dashboard.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';

import { tableHeader } from '../../../../models/AccountDetailsVM';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-grower-lannding',
  templateUrl: './grower-landing.component.html',
})

export class GrowerLandingComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  ApiData: any[];

  // set table header data
  headerList: tableHeader[] = [];
  // data souce list
  dataSourceList: any[] = [];
  // set filter
  filterArray: any[] = [];

  constructor(private loaderService: LoaderService,
    private dashboardService: DashboardService,
    private localStorageService: LocalStorageService) {
    // set header list data
    this.headerList = [
      { headertxt: 'Grower', columnfield: 'grower', className: 'mat-header-cell accountId' },
      { headertxt: 'Phone Number', columnfield: 'phoneNo', className: 'mat-header-cell accountName' },
      { headertxt: 'Email', columnfield: 'email', className: 'mat-header-cell accountCity' },
      { headertxt: 'Action', columnfield: 'action', className: 'mat-header-cell accountCity' }
    ];
    // set filter list data
    this.filterArray = [
      { label: 'GMK', column: 'GMK' },
      { label: 'GLN', column: 'GLN' },
      { label: 'First Name', column: 'FirstName' },
      { label: 'Last Name', column: 'LastName' },
      { label: 'Business Name', column: 'BusinessName' },
      { label: 'City', column: 'City' },
      { label: 'State', column: 'State' },
      { label: 'Account', column: 'Account' }
    ];
  }

  ngOnInit() {
    // Set the default value
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getGrowerOrderData(this.headerYear, this.headerCompany);
  }

  getGrowerOrderData(cropYear, companyCode) {
    this.loaderService.setLoaderStatus(true);

    const filter = {
      cropYear: cropYear,
      shipToAccount: 0
    };

    this.subscription.push(this.dashboardService.getGrowerOrder(filter).subscribe(results => {
      this.dataSourceList = [];
      // filled data source with API data
      const data = results as any[];
      data.forEach(x => this.dataSourceList.push({
        grower: x.growerName + x.GrowerAddress,
        growerInnerHtml: '<p class="grower-name"><a>' + x.growerName + '</a></p><p> ' + x.growerAddress + '</p>',
        phoneNo: x.phoneNo,
        email: x.email,
        actionInnerHtml: '<a>View Grower Order</a>'
      }));

      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    })));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
